import {styled} from "styled-components"

import {Select} from "@irati/ui/src/FormItem"
import {Body, Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {breakWord} from "@irati/ui/src/global/helpers"
import {IconTooltip} from "@irati/ui/src/Tooltip"
import Form from "@irati/ui/src/Form"

import FilterChipToggle from "../../components/FilterChipToggle"
import {ReactTable} from "../../components/Table"

export const StyledSelect = styled(Select)`
  margin-bottom: 0;
`

export const BlackCircle = styled(Label)`
  font-size: 70%;
  padding: 0px 4px;
`

export const StyledBody = styled(Body)`
  ${breakWord}
  white-space: pre-line;
`

export const CommentContainer = styled(Flex)`
  border: 1px solid rgba(61, 61, 54, 0.25);
  padding: 12px;
  border-radius: 4px;
`

export const FlexChildLabel = styled(Label)`
  flex: 1 1 0;
`

export const StyledReactTable = styled(ReactTable)`
  .rt-tbody .rt-td {
    border-right: none;
  }
  .rt-td {
    align-self: center;
  }
`

export const FlexChild = styled.div`
  flex: 1;
  position: relative;
`

export const StyledIconTooltip = styled(IconTooltip)`
  position: absolute;
  right: 0;
  top: 4px;
`

export const StyledFilterChipToggle = styled(FilterChipToggle)`
  height: 50px;
  padding-left: 14px;
  width: 40px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
`

export const StyledForm = styled(Form)`
  flex: 1;
  .form-control {
    border-right: 0;
  }
  span.input-group .form-control + .input-group-addon {
    box-shadow: none;
    border-left: 0;
    padding: 0;
  }
`
